import { render, staticRenderFns } from "./FilterDataTable.vue?vue&type=template&id=12ca204c&"
import script from "./FilterDataTable.vue?vue&type=script&lang=js&"
export * from "./FilterDataTable.vue?vue&type=script&lang=js&"
import style0 from "./FilterDataTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports